import React, { useEffect, useRef, useState } from 'react';
import { COLOR } from '@src/styles/color';
import { formatAudioTime } from '@src/utils/time';
import CommonButton from '@src/new-components/Button';
import { getAudioUrl } from '@src/services/instantVoiceCloning';
import Typography from '@src/new-components/Typography';
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded';
import PauseRoundedIcon from '@mui/icons-material/PauseRounded';
import WrapperStepContent from '../WrapperStepContent';
import {
  StyledAudioInfo,
  StyledAudioPlayer,
  StyledPreviewAudio,
} from './index.style';

const PreviewAudio = ({ fileUpload, onSetStep }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);

  const audioUrl = getAudioUrl(fileUpload);

  useEffect(
    () =>
      // Clean up object URL if fileUpload is a File
      () => {
        if (fileUpload instanceof File && audioUrl) {
          URL.revokeObjectURL(audioUrl);
        }
      },
    [fileUpload, audioUrl],
  );

  useEffect(() => {
    if (!isPlaying) {
      audioRef.current?.pause();
    } else {
      audioRef.current?.play();
    }
  }, [isPlaying]);

  const handlePlayPause = () => {
    if (!audioUrl) return;
    setIsPlaying((prev) => !prev);
  };

  const handleAudioEnded = () => {
    setIsPlaying(false);
  };

  const handleLoadedMetadata = (e) => {
    setDuration(e.target.duration);
  };

  return (
    <WrapperStepContent onSetStep={onSetStep}>
      <StyledPreviewAudio>
        {/* Audio player UI */}
        <StyledAudioPlayer>
          <CommonButton
            onClick={handlePlayPause}
            variant="contained"
            color="primary"
            sx={{
              borderRadius: '50%',
              minWidth: '40px !important',
              minHeight: '40px !important',
              padding: '0 !important',
            }}
            disabled={!audioUrl}
          >
            {isPlaying ? <PauseRoundedIcon /> : <PlayCircleRoundedIcon />}
          </CommonButton>
          <StyledAudioInfo>
            <Typography
              component="span"
              variant="body-16-medium"
              color={COLOR.black.default}
            >
              {fileUpload?.name}
            </Typography>
            <Typography
              component="span"
              variant="body-14-regular"
              color={COLOR.descriptionUpload}
            >
              {formatAudioTime(duration)}
            </Typography>
          </StyledAudioInfo>
          <audio
            ref={audioRef}
            src={audioUrl}
            onEnded={handleAudioEnded}
            onLoadedMetadata={handleLoadedMetadata}
            style={{ display: 'none' }}
          >
            <track kind="captions" />
          </audio>
        </StyledAudioPlayer>
      </StyledPreviewAudio>
    </WrapperStepContent>
  );
};

export default PreviewAudio;
